import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { Button, Classes, Dialog, Intent, MenuItem } from '@blueprintjs/core';
import { observer } from 'mobx-react';
import { IconNames } from '@blueprintjs/icons';
import { SystemStatus } from '../../store/models/SystemStatus';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import { Form } from 'react-final-form';
import { TextInputFormField } from '../common/form';
import { toJS } from 'mobx';
import SelectInputFormField from '../common/form/SelectInputFormField';
import DateInputFormField from '../common/form/DateInputFormField';
import { IItemRendererProps } from '@blueprintjs/select';
import { BankHolidayDate } from '../../store/models/BankHolidayDate';

interface BankHolidayDateFormProps extends WithTranslateProps {
  bankHolidayDate?: Instance<typeof BankHolidayDate>;
  bankHolidayList: any[];
  onSave: (data) => void;
  onStop: () => void;
  status: string[];
}

@observer
class BankHolidayDateForm extends React.Component<BankHolidayDateFormProps> {
  renderBankHolidayItem(item: any, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return <MenuItem key={`bk-${index}`} active={modifiers.active} onClick={handleClick} text={item.code} />;
    } else {
      return null;
    }
  }

  filterStatus = (query, bankHoliday) => {
    return bankHoliday.code.indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { onSave, onStop, bankHolidayDate, bankHolidayList } = this.props;
    return (
      <Dialog
        isOpen={bankHolidayDate !== undefined}
        onClose={onStop}
        icon={IconNames.EDIT}
        title={
          <TranslatedMessage
            id={
              this.state && bankHolidayDate && bankHolidayDate.bankHolidayDateId === -1
                ? TLCode.SECRETARIAT_DASHBOARD_CreateStatus
                : TLCode.SECRETARIAT_DASHBOARD_EditStatus
            }
          />
        }
      >
        {bankHolidayDate && (
          <div className={Classes.DIALOG_BODY}>
            <Form
              initialValues={bankHolidayDate}
              onSubmit={onSave}
              render={({ handleSubmit, hasValidationErrors, dirty }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    {/* <TextInputFormField
                      name="date"
                      label={TLCode.SECRETARIAT_DASHBOARD_BankHolidayDateLabel}
                      inline={true}
                      required={true}
                      fill={true}
                      autoFocus={true}
                      disabled={bankHolidayDate.bankHolidayDateId > 0}
                    /> */}
                    <DateInputFormField name="date" label={TLCode.SECRETARIAT_DASHBOARD_BankHolidayDateLabel} inline={true} fill={true} maxDate={new Date("2099-12-31")}/>
                    <SelectInputFormField
                      label={TLCode.SECRETARIAT_DASHBOARD_BankHolidayLabel}
                      name="code"
                      inline={true}
                      items={bankHolidayList}
                      itemValueGetter={(item: any) => item.code}
                      valueItemGetter={(value) => ({ id: value, label: value })}
                      inputValueRenderer={(item) => (item != null ? item.id : '')}
                      itemRenderer={this.renderBankHolidayItem}
                      itemPredicate={this.filterStatus}
                      identifier={'id'}
                      elementLabel={'label'}
                      labelSelectAnElement={this.props.translate(TLCode.SECRETARIAT_DASHBOARD_SelectBankHoliday)}
                      helperText={this.props.translate(TLCode.SECRETARIAT_DASHBOARD_SelectBankHoliday)}
                      placeholderSelection={TLCode.SECRETARIAT_DASHBOARD_SelectBankHoliday}
                    />
                    <div className={Classes.DIALOG_FOOTER}>
                      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text={<TranslatedMessage id={TLCode.GENERAL_Cancel} />} onClick={onStop} />
                        <Button
                          type="submit"
                          intent={Intent.PRIMARY}
                          disabled={hasValidationErrors || (!dirty && bankHolidayDate.bankHolidayDateId > 0)}
                          text={<TranslatedMessage id={TLCode.GENERAL_Save} />}
                        />
                      </div>
                    </div>
                  </form>
                );
              }}
            />
          </div>
        )}
      </Dialog>
    );
  }
}

export default withTranslate(BankHolidayDateForm);
